/* Noctimoth · product page conversion blocks */
(function () {
  /* Bundle tiers -> quantity */
  document.querySelectorAll('[data-nm-buy]').forEach(function (form) {
    var qty = form.querySelector('[data-nm-qty]');
    var tiers = form.querySelectorAll('.nm-tier');
    function sync() {
      tiers.forEach(function (t) {
        var r = t.querySelector('input');
        t.classList.toggle('is-active', r.checked);
        if (r.checked && qty) qty.value = r.value;
      });
    }
    tiers.forEach(function (t) { t.querySelector('input').addEventListener('change', sync); });
    sync();

    /* Subscription toggle (only rendered when a subscription app is active) */
    var plan = form.querySelector('[data-nm-plan]');
    var once = form.querySelector('[data-nm-once]');
    if (plan && once) {
      var planId = plan.value;
      var perks = form.querySelector('[data-nm-perks]');
      var txt = form.querySelector('[data-nm-once-text]');
      once.addEventListener('click', function () {
        var subscribe = plan.value === '';
        plan.value = subscribe ? planId : '';
        once.textContent = subscribe ? once.dataset.on : once.dataset.off;
        if (perks) perks.hidden = !subscribe;
        if (txt) txt.hidden = !subscribe;
      });
    }
  });

  /* Review slider */
  document.querySelectorAll('[data-nm-reviews]').forEach(function (el) {
    var track = el.querySelector('.nm-reviews__track');
    var items = track.children;
    var dots = el.querySelector('.nm-reviews__dots');
    if (items.length < 2) return;
    for (var i = 0; i < items.length; i++) (function (i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Review ' + (i + 1));
      d.addEventListener('click', function () { track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(d);
    })(i);
    function mark() {
      var idx = Math.round(track.scrollLeft / Math.max(1, items[0].offsetWidth + 12));
      Array.prototype.forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
      return idx;
    }
    track.addEventListener('scroll', mark, { passive: true });
    mark();
    setInterval(function () {
      if (el.matches(':hover')) return;
      var next = (mark() + 1) % items.length;
      track.scrollTo({ left: items[next].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }, 5000);
  });
})();
